import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import style from "./QRViewModal.module.css"

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import QrcodeVorteilspartner from '../pages/Vorteilspartner/QrcodeVorteilspartner'

const Backdrop = (props) => {
    return <div className={style.backdrop} onClick={props.onConfirm} />
}

const ModalOverlay = (props) => {

  return (
      <Modal show={props.visible} onHide={() => props.visible(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title><span style={{fontSize: "70%"}}>Vorteilspartner: {props.title}</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {/*<img id="myimg" src={props.img} style={{width: "800px", height: "800px"}} />*/}
            {/*<img
              src={props.imgSrc}
              style={{
                width:"100%",
                height: "100%"
              }} />*/}
          <QrcodeVorteilspartner id={props.id} vorteilId={props.vorteilId}/>
        </Modal.Body>
        <Modal.Footer>
          <p
            style={{ fontSize: "100%", display: "flex", justifyContent: "flex-end", width: "auto !important", background: "#520da7", padding: "15px", color: "white", fontWeight: "bold", borderRadius: "8px", cursor: "pointer" }}
            onClick={() => props.visible(false)}
            >
            Schließen
          </p>
        </Modal.Footer>
      </Modal>
  )
}

const QRViewModal = (props) => {

    return (
      <Fragment>
        {ReactDOM.createPortal(<Backdrop hideModal={props.hideModal} />, document.getElementById('backdrop-root'))}
        {ReactDOM.createPortal(<ModalOverlay title={props.title} id={props.id} vorteilId={props.vorteilId} visible={props.visible} />, document.getElementById('overlay-root'))}
      </Fragment>
      
    )
}

export default QRViewModal